import script from "./sandFileContent.vue?vue&type=script&setup=true&lang=js"
export * from "./sandFileContent.vue?vue&type=script&setup=true&lang=js"

import "./sandFileContent.vue?vue&type=style&index=0&id=59a5b36e&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/qixiao_410_6413_沙箱云前端生产环境/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59a5b36e"]])

export default __exports__